import React from "react";
import { ToastContext } from "./Provider";

const useToasts = () => React.useContext(ToastContext);

export default useToasts;
